class packets {
	constructor(config) {
		this.config = Object.assign({
			scope: '.packets',
			button: '.icon-scroll'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.button, this.scrollPackets.bind(this))
	}

	scrollPackets(event) {
		let $div = $('div.scroll-div');
		let pos = $div.scrollLeft() + 155;
		$div.scrollLeft(pos);
	}
}

export default new packets;